import { useDispatch } from 'react-redux';

import axiosPrivate from 'config/axiosPrivate';

import { animationUrl } from 'config/endpoints';

import { transformToSemanticGap } from 'helpers/FormatKeywordsHelper';

import { updateForm } from 'store/Client/ClientAnalyser';

export const useClientTextSave = ({
  textId,
  actualHtmlContent,
  actualTextContent,
  analyseResult,
  keyword,
  titleTag,
  metaDescriptionTag,
  combinedKeywords,
  url,
  t,
  setIsSave,
  setErrorSuccessMsg,
  setErrorSuccessImg,
  setIsSuccess,
  setErrorSuccess,
}) => {
  const dispatch = useDispatch();

  const handleSave = () => {
    setIsSave(true);
    const data = {
      actualHtmlContent,
      actualTextContent,
      analyseResult: analyseResult && JSON.stringify(analyseResult),
      keyword,
      titleTag,
      metaDescriptionTag,
      semanticGap: transformToSemanticGap(combinedKeywords),
      url: url,
    };
    axiosPrivate
      .put(`/texts/${textId}/client-deliver`, data)
      .then((res) => {
        dispatch(updateForm(res.data));
        setErrorSuccessMsg(`${t('Le texte a été enregistré avec succès')}!`);
        setErrorSuccessImg(animationUrl + '/05_Contenu_livré.gif');
        setIsSuccess(true);
        setErrorSuccess(true);
      })
      .catch(() => {
        setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
        setIsSuccess(false);
        setErrorSuccess(true);
      });
  };

  return {
    handleSave,
  };
};
